import { Box, Icon, TFCard, TFEmptyStateMessage } from '@tf/ui';

import { useAccountParams, useEntityConnectionLabels, useSelectedAccount } from '@/core/hooks';
import { AddConnectionButton } from '@/components/shared';

export const EmptyConnectionScreen = () => {
	const { connectionKind } = useAccountParams();
	const { meta } = useSelectedAccount();

	const connectionLabels = useEntityConnectionLabels(meta.entityKind);
	const label = connectionLabels[connectionKind].singular;
	const title = connectionLabels[connectionKind].plural;

	return (
		<Box sx={({ breakpoints }) => ({ margin: '.75rem auto', maxWidth: breakpoints.xl })}>
			<TFCard>
				<TFEmptyStateMessage
					title={title}
					icon={<Icon.IconLinkPlus />}
					primaryAction={
						<AddConnectionButton
							label={label}
							connectionKind={connectionKind}
							parentEntity={{ kind: meta.entityKind, graphId: meta.graphNodeId }}
							buttonProps={{
								fullWidth: false,
								size: 'md',
								variant: 'gradient',
								gradient: { from: 'brand', to: 'blue' },
							}}
						/>
					}
				/>
			</TFCard>
		</Box>
	);
};
